module.exports = __webpack_public_path__ + "img/thumbnail_NorthAmericanBeaver_m_normal.d130d427.png";